export class POrderPortailAuthSessionDto {
    ID: string;
    NOM: string;
    PRENOM: string;
    USERNAME: string;
    EMAIL: string;
    HAS_DEFAULT_PASSWORD: boolean;
    AccessToken: string;
    RefreshToken: string;
    USER_PERMS: any[];
    CODE_PIN: string;
    MFA_ENABLED: boolean;
    LICENCE_DATE_EXPIRATION: string;
}

export class POrderPortailOrder {
    ID?: number;
    NUM_ORDER?: string;
    RAISON_SOCIALE: string;
    NOM: string;
    PRENOMS: string;
    EMAIL: string;
    TELEPHONE: string;
    ADRESSE: string;
    INFOS_COMPLEMENTAIRES: string;
    DATE_CREATION: Date;
    QUANTITE: number;
    DO_TOTALHT: number;
    DO_TOTALTTC: number;
    ORDER_ITEMS: POrderPortailOrderItem[];
}

export class POrderPortailOrderItem {
    AR_REF: string;
    AR_DESIGN: string;
    FA_FAMNV1: string;
    FA_FAMNV1LIB: string;
    AG_NO1: string;
    AG_NO1LIB: string;
    AG_NO2: string;
    AG_NO2LIB: string;
    AR_IMG_DATA?: string;
    AR_PRIXVEN: number;
    QUANTITE: number;
    DATE_CREATION: Date;
    DL_NO: number;
    DL_TOTALHT: number;
    DL_TOTALTTC: number;
}

export class POrderPortailCart {
    ID?: number;
    DATE_CREATION: Date;
    QUANTITE: number;
    DO_TOTALHT: number;
    DO_TOTALTTC: number;
    PANIER_ITEMS: POrderPortailCartItem[] = [];
}

export class POrderPortailCartItem {
    DL_ID: string;
    AR_REF: string;
    AR_DESIGN: string;
    FA_FAMNV1: string;
    FA_FAMNV1LIB: string;
    AG_NO1: string;
    AG_NO1LIB: string;
    AG_NO2: string;
    AG_NO2LIB: string;
    AR_IMG_DATA?: string;
    AR_PRIXVEN: number;
    QUANTITE: number;
    DATE_CREATION: Date;
    DL_NO: number;
    DL_TOTALHT: number;
    DL_TOTALTTC: number;
}

export enum PORTAIL_ORDER_CATEGORY_TYPE {
    FAMILLES = 'FAMILLES',
    CATALOGUES = 'CATALOGUES',
}

export enum PORTAIL_ORDER_PRODUCTS_SORT {
    NAME_ASC = 'NAME_ASC',
    NAME_DESC = 'NAME_DESC',
    PRICE_ASC = 'PRICE_ASC',
    PRICE_DESC = 'PRICE_DESC'
}

export const PORTAIL_ORDER_PRODUCTS_SORT_LABELS: {[key: string]: string} = {
    'NAME_ASC': 'Ordre Alphabetique [A-Z]',
    'NAME_DESC': 'Ordre Alphabetique [Z-A]',
    'PRICE_ASC': 'Prix [Croissant]',
    'PRICE_DESC': 'Prix [Décroissant]'
}

export const PORTAIL_ORDER_PRODUCTS_SORT_OPTIONS = [
    { mVALUE_MEMBER: PORTAIL_ORDER_PRODUCTS_SORT.NAME_ASC, mDISPLAY_MEMBER: PORTAIL_ORDER_PRODUCTS_SORT_LABELS[PORTAIL_ORDER_PRODUCTS_SORT.NAME_ASC] },
    { mVALUE_MEMBER: PORTAIL_ORDER_PRODUCTS_SORT.NAME_DESC, mDISPLAY_MEMBER: PORTAIL_ORDER_PRODUCTS_SORT_LABELS[PORTAIL_ORDER_PRODUCTS_SORT.NAME_DESC] },
    { mVALUE_MEMBER: PORTAIL_ORDER_PRODUCTS_SORT.PRICE_ASC, mDISPLAY_MEMBER: PORTAIL_ORDER_PRODUCTS_SORT_LABELS[PORTAIL_ORDER_PRODUCTS_SORT.PRICE_ASC] },
    { mVALUE_MEMBER: PORTAIL_ORDER_PRODUCTS_SORT.PRICE_DESC, mDISPLAY_MEMBER: PORTAIL_ORDER_PRODUCTS_SORT_LABELS[PORTAIL_ORDER_PRODUCTS_SORT.PRICE_DESC] },
];

export enum PORTAIL_ORDER_STATUS_COMMANDE {
    REJECTED = -2,
    CANCELLED = -1,
    PENDING = 0,
    CONFIRMED = 1,
    PROCESSING = 2,
    PROCESSED = 3,
}

export const PORTAIL_ORDER_STATUS_COMMANDE_LABELS: {[key: number]: string} = {
    [-2]: 'Rejetée',
    [-1]: 'Annulé',
    [0]: 'En attente',
    [1]: 'Confirmé',
    [2]: 'Intégration en cours',
    [3]: 'Intégrée',
}

export const PORTAIL_ORDER_STATUS_COMMANDE_COLORS: {[key: number]: string} = {
    [-2]: 'badge-danger',
    [-1]: 'badge-danger',
    [0]: 'badge-light',
    [1]: 'badge-info',
    [2]: 'badge-light',
    [3]: 'badge-success'
}

export const PORTAIL_ORDER_STATUS_COMMANDE_OPTIONS = [
    { mVALUE_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE.PENDING, mDISPLAY_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE_LABELS[PORTAIL_ORDER_STATUS_COMMANDE.PENDING] },
    { mVALUE_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE.CANCELLED, mDISPLAY_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE_LABELS[PORTAIL_ORDER_STATUS_COMMANDE.CANCELLED] },
    { mVALUE_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE.CONFIRMED, mDISPLAY_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE_LABELS[PORTAIL_ORDER_STATUS_COMMANDE.CONFIRMED] },
    { mVALUE_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE.REJECTED, mDISPLAY_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE_LABELS[PORTAIL_ORDER_STATUS_COMMANDE.REJECTED] },
    { mVALUE_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE.PROCESSING, mDISPLAY_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE_LABELS[PORTAIL_ORDER_STATUS_COMMANDE.PROCESSING] },
    { mVALUE_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE.PROCESSED, mDISPLAY_MEMBER: PORTAIL_ORDER_STATUS_COMMANDE_LABELS[PORTAIL_ORDER_STATUS_COMMANDE.PROCESSED] },
];

export enum PORTAIL_ORDER_NOMENCLATURE {
    AUCUNE = 0,
    FABRICATION = 1,
    COMMERCIAL_COMPOSE = 2,
    COMMERCIAL_COMPOSANT = 3,
    ARTICLES_LIES = 4,
}

export const PORTAIL_ORDER_NOMENCLATURE_LABELS: {[key: number]: string} = {
    [0]: 'Aucune',
    [1]: 'Fabrication',
    [2]: 'Commerciale / Composé',
    [3]: 'Commercial / Composant',
    [4]: 'Articles liés',
}